module.exports = __webpack_public_path__ + "img/sign.73c29c85.png";